import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../../../../../../shared/types';
import { handleError } from '../../../../../../ui/err/handleError';
import { aiAgentApis } from '../../../../../../../shared/apis/ai-agent/apis';
import { showSuccessNotification } from '../../../../../../ui/notification';
import { queries } from '../../../../../../../shared/queries';

export default function usePutMgptUse() {
  const queryClient = useQueryClient();
  return useMutation(aiAgentApis.model.putActivateMgpt, {
    onSuccess: () => {
      showSuccessNotification('변경 되었습니다.');
      queryClient.invalidateQueries({ queryKey: queries.aiAgent.equipmentModelList._def });
    },
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
